<template>
  <li class="list-group-item" style="padding-right: 0;">
    <span style="width: 20px; display: inline-block;" class="handle">
      <i class="fas fa-arrows-alt-v"></i>
    </span>
    <template v-if="!editMode">
      {{ option.value }}
      <div class="text-right" style="float: right">
        <span class="fa-stack" v-if="option.ignore_for_create_variations">
          <i class="fa fa-tshirt fa-stack-1x"></i>
          <i class="fa fa-slash fa-stack-1x text-danger"></i>
        </span>
        <button class="btn btn-warning btn-link btn-sm"
          v-tooltip.top-center="'Bearbeiten'"
          @click="enterEditMode"
        >
          <i class="fas fa-edit text-warning"></i>
        </button>
        <button v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-sm"
          @click="$emit('deleteOption', option)"
        >
          <i class="fa fa-close text-danger"></i>
        </button>
      </div>
    </template>
    <template v-else>
      <input class="form-control quick-input" v-model="optionToEdit.value" style="display: inline-block; width: 220px;">
      <div class="text-right" style="float: right">
        <button class="btn btn-warning btn-link btn-sm"
          v-tooltip.top-center="'Speichern'"
          @click="saveEdit"
        >
          <i class="fas fa-check text-success"></i>
        </button>
        <button v-tooltip.top-center="'Abbrechen'" class="btn btn-danger btn-link btn-sm"
          @click="cancelEdit"
        >
          <i class="fa fa-close text-danger"></i>
        </button>
      </div>
      <l-checkbox id="nowrap" v-model="optionToEdit.ignore_for_create_variations">ignorieren</l-checkbox>
    </template>
  </li>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: ['option', 'createVariations'],
  data () {
    return {
      editMode: false,
      optionToEdit: null
    }
  },
  methods: {
    enterEditMode () {
      this.optionToEdit = cloneDeep(this.option)
      this.editMode = true
    },
    saveEdit () {
      this.$emit('saveEdit', this.optionToEdit)
      this.editMode = false
    },
    cancelEdit () {
      this.editMode = false
    }
  }
}
</script>

<style>
</style>
